import { OTLPConfig, SeverityNumber } from '@thoughtspot/observability';

const SERVICE_NAME = 'blink-v2';
const otelEndpoint = '/otel/v1';

export const OTLP_CONFIG: OTLPConfig = {
    traces: {
        url: `${otelEndpoint}/traces`,
        flushConfig: {
            flushIntervalMs: 10000,
            maxQueueSize: 1000,
            flushOnFull: true,
        },
    },
    metrics: {
        url: `${otelEndpoint}/metrics`,
        flushConfig: {
            flushIntervalMs: 15000,
            maxQueueSize: 1000,
            flushOnFull: true,
        },
    },
    logs: {
        url: `${otelEndpoint}/logs`,
        flushConfig: {
            flushIntervalMs: 5000,
            maxQueueSize: 200,
            flushOnFull: true,
        },
        severityMap: {
            [SeverityNumber.UNSPECIFIED]: 'otlp',
            [SeverityNumber.ERROR]: ['console', 'otlp'],
            [SeverityNumber.WARN]: ['console', 'otlp'],
        },
    },
    serviceName: SERVICE_NAME,
};
